import { toast } from "react-toastify";
import { authTokenRegistry } from "@hoteltradergit/user-management/auth";
import { getLoggedInUserId, getLoggedInUsername } from "./tokenAccessor";

// User-attributed mutations (EO-402 audit trail) must never reach the backend
// without a real actor. A missing username/userId here means the stored token
// is gone or malformed — the same invalid-session state a backend 401 signals —
// so these guards funnel into the auth lib's forceLogout, which runs the
// canonical logout flow (store reset, Heap reset, storage clear, cross-tab
// broadcast) and lands the user back on the login page.
//
// Callers must treat a null return as "abort the action": the redirect is
// already in flight.
const invalidSession = () => {
  toast.error("Invalid session, Please login to continue");
  authTokenRegistry.forceLogout();
  return null;
};

export const requireLoggedInUsername = () => {
  const username = getLoggedInUsername();
  return username || invalidSession();
};

export const requireLoggedInUserId = () => {
  const userId = getLoggedInUserId();
  return userId && !Number.isNaN(userId) ? userId : invalidSession();
};
